export const USER_CIRCLE_QUERY_PARAM = "userCircles.circle.id";
export const USER_SUB_CIRCLE_QUERY_PARAM = "userCircles.userSubCircles.subCircle.id";
